<template>
	<div class="mb-10">
		<ux-form ref="form" @submit.prevent="submit">
			<ux-text-field
				hide-label
				:disabled="saving"
				:rules="rules.code"
				label="Enter coupon code below"
				placeholder="Enter coupon code here"
				v-model="promoCode"
			/>

			<ux-btn type="submit" color="outline-primary" :loading="saving">Add Promo Code</ux-btn>
		</ux-form>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import api from 'frontend/api';
import alerts from 'common/alerts';

export default {
	data()
	{
		return {
			promoCode: '',
			saving: false,

			rules: {
				code: [ v => !!v || 'Please enter a promo code' ],
			}
		}
	},

	methods: {
		...mapActions('checkout', ['fetchCheckoutSummary']),

		async submit()
		{
			if (!this.$refs.form.validate() )
				return;

			this.saving = true;

			try
			{
				await api.post('/checkout/promo_codes', { code: this.promoCode });
				
				await alerts.show('Promo code added successfully', 'Success', 'success');

				await this.fetchCheckoutSummary();

				this.promoCode = '';
			}
			finally
			{
				this.saving = false;
			}
		}
	}
}
</script>